import { render, staticRenderFns } from "./BroughtTogetherTile.vue?vue&type=template&id=49a0ae37"
import script from "./BroughtTogetherTile.vue?vue&type=script&lang=js"
export * from "./BroughtTogetherTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Stars: require('/vercel/path0/components/Stars.vue').default})
